"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const FacebookError_1 = require("./FacebookError");
const FACEBOOK_URL = process.env.FACEBOOK_URL;
const FACEBOOK_BASIC_AUTH_USER = process.env.FACEBOOK_BASIC_AUTH_USER;
const FACEBOOK_BASIC_AUTH_PASSWORD = process.env.FACEBOOK_BASIC_AUTH_PASSWORD;
class FacebookClient extends base_client_1.ApiBasicAuthClient {
    constructor(url = FACEBOOK_URL, user = FACEBOOK_BASIC_AUTH_USER, password = FACEBOOK_BASIC_AUTH_PASSWORD) {
        super({
            baseURL: `${url}/v1/`,
            basicAuthUser: user,
            basicAuthPassword: password,
        });
        if (!user || !password) {
            commons_logs_1.log.warn("Missing FACEBOOK_BASIC_AUTH_USER and FACEBOOK_BASIC_AUTH_PASSWORD environment variables");
        }
    }
    async registerSeller(sellerId, sellerRegistrationData) {
        try {
            return await this.post(`/seller/${sellerId}`, sellerRegistrationData);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                FacebookError_1.FacebookError.BUSINESS_USER_NOT_FOUND,
                FacebookError_1.FacebookError.FB_USER_IS_NOT_ADMIN,
                FacebookError_1.FacebookError.INVALID_OAUTH_ACCESS_TOKEN,
                FacebookError_1.FacebookError.MULTIPLE_SHOPIFY_PRODUCT_CATALOGS,
                FacebookError_1.FacebookError.SHOPIFY_PRODUCT_CATALOG_NOT_FOUND,
            ]);
        }
    }
    async refreshSeller(sellerId) {
        try {
            await this.post(`refresh/seller/${sellerId}`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.SELLER_NOT_FOUND, FacebookError_1.FacebookError.REFRESH_ALREADY_IN_PROGRESS]);
        }
    }
    async getAllSellers(limit, offset, filters = {}) {
        try {
            return await this.get(`/sellers`, Object.assign({ limit,
                offset }, filters));
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getSeller(sellerId) {
        try {
            return await this.get(`/seller/${sellerId}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.SELLER_NOT_FOUND]);
        }
    }
    async getSellerRegistrationAssetData(sellerId) {
        try {
            return await this.get(`/seller/${sellerId}/registrationassetdata`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.SELLER_NOT_FOUND]);
        }
    }
    async activateSeller(sellerId) {
        try {
            return await this.put(`/seller/${sellerId}/activate`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.SELLER_NOT_FOUND]);
        }
    }
    async deactivateSeller(sellerId) {
        try {
            return await this.delete(`/seller/${sellerId}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.SELLER_NOT_FOUND]);
        }
    }
    async getAdAccounts(sellerId, userId, accessToken) {
        try {
            return await this.get(`/seller/${sellerId}/user/${userId}/token/${accessToken}/ad-accounts`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.INVALID_OAUTH_ACCESS_TOKEN]);
        }
    }
    async getPages(sellerId, userId, accessToken) {
        try {
            return await this.get(`/seller/${sellerId}/user/${userId}/token/${accessToken}/pages`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.INVALID_OAUTH_ACCESS_TOKEN]);
        }
    }
    async getInstagramAccounts(sellerId, businessId, accessToken) {
        try {
            return await this.get(`/seller/${sellerId}/business/${businessId}/token/${accessToken}/instagram-accounts`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.INVALID_OAUTH_ACCESS_TOKEN]);
        }
    }
    async getPixels(sellerId, adAccountId, accessToken) {
        try {
            return await this.get(`/seller/${sellerId}/ad-account/${adAccountId}/token/${accessToken}/pixels`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.INVALID_OAUTH_ACCESS_TOKEN]);
        }
    }
    async hasValidPermissions(sellerId, userId, accessToken) {
        try {
            return await this.get(`/seller/${sellerId}/user/${userId}/token/${accessToken}/permissions`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.INVALID_OAUTH_ACCESS_TOKEN]);
        }
    }
    async syncSellerCreatedAdSets(sellerId) {
        try {
            return await this.post(`/sync-seller-created-ad-sets/seller/${sellerId}`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [FacebookError_1.FacebookError.SELLER_NOT_FOUND]);
        }
    }
}
exports.FacebookClient = FacebookClient;
//# sourceMappingURL=FacebookClient.js.map